// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Component as RawComponent } from "lucide-react";
export const Component = /* @__PURE__ */ createIcon(RawComponent, "Component", 2);
